import React, { useEffect, useState } from "react";
import hamdanHistory from "../assets/images/about-hamdan-trading-group.jpg";
import { easeOut, motion, Variants } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLanguage } from "../context/LanguageContext";

const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeOut } },
};

const draw: Variants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i: number) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { delay: 0.5 + i * 0.3, type: "spring", duration: 1, bounce: 0 },
      opacity: { delay: 0.5 + i * 0.3, duration: 0.3 },
    },
  }),
  hover: { pathLength: 1.1, strokeWidth: 3, transition: { duration: 0.3 } },
};

const HistorySection: React.FC = () => {
  const [content, setContent] = useState<any>(null);
  const { t_api } = useLanguage();
  const [ref, inView] = useInView({ triggerOnce: false, threshold: 0.2 });

  useEffect(() => {
    fetch('/api/homepage/content')
      .then(res => res.json())
      .then(data => setContent(data.History || {}))
      .catch(err => console.warn('History content unavailable:', err));
  }, []);

  const points = [
    { title: t_api(content?.point_1_title || "Heritage", content?.point_1_title_ar || "تراثنا"), description: t_api(content?.point_1_subtitle || "Since 1975", content?.point_1_subtitle_ar || "منذ عام 1975") },
    { title: t_api(content?.point_2_title || "Diversity", content?.point_2_title_ar || "التنوع"), description: t_api(content?.point_2_subtitle || "14+ Business Units", content?.point_2_subtitle_ar || "14+ وحدة عمل") },
    { title: t_api(content?.point_3_title || "Excellence", content?.point_3_title_ar || "التميز"), description: t_api(content?.point_3_subtitle || "Industry Benchmarks", content?.point_3_subtitle_ar || "معايير قطاع الأعمال") },
    { title: t_api(content?.point_4_title || "Growth", content?.point_4_title_ar || "النمو"), description: t_api(content?.point_4_subtitle || "Omani Economy", content?.point_4_subtitle_ar || "الاقتصاد العماني") },
  ];

  return (
    <section ref={ref} className="relative pt-12 pb-16 bg-cover bg-center bg-no-repeat bg-fixed"
      style={{ backgroundImage: `url(${content?.bg_image || hamdanHistory})`, minHeight: "75vh" }}>
      <div className="absolute inset-0 z-0 bg-black opacity-60" />
      <motion.div variants={fadeInUp} initial="hidden" animate={inView ? "visible" : "hidden"} className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 h-full flex flex-col justify-center">
        <div className="mb-6 mt-6">
          <h2 className="text-3xl font-bold text-white text-left">{t_api(content?.title || "Hamdan In 1975", content?.title_ar || "مجموعة حمدان منذ 1975")}</h2>
          <div className="w-16 h-1 bg-[#F2BB13] mt-4"></div>
        </div>
        <div className="text-left w-full">
          {t_api(content?.desc || "Hamdan Trading Group is part of one of the largest corporate conglomerates in the Sultanate of Oman...", content?.desc_ar || "تعتبر مجموعة حمدان التجارية جزءاً من أكبر المجموعات الاقتصادية والتجارية في سلطنة عمان، وتساهم بشكل فعال في بناء وتطوير الاقتصاد الوطني منذ عام 1975.").split('\n').filter(Boolean).map((para: string, i: number) => (
            <p key={i} className="text-white text-base sm:text-lg md:text-xl leading-relaxed mb-6" dangerouslySetInnerHTML={{ __html: para }} />
          ))}
        </div>
        <div className="grid grid-cols-2 xs:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mt-8">
          {points.map((value: any, index: number) => (
            <motion.div key={index} className="relative group" initial="hidden" animate={inView ? "visible" : "hidden"} custom={index} whileHover="hover">
              <motion.svg width="100%" height="100" viewBox="0 0 200 100" className="absolute inset-0">
                <motion.rect x="5" y="5" width="190" height="90" rx="10" stroke="#F2BB13" strokeWidth="2" fill="transparent" variants={draw as any} custom={index} />
              </motion.svg>
              <div className="p-4 sm:p-6 h-full flex flex-col justify-center items-center text-center">
                <h3 className="text-xl sm:text-2xl font-bold text-[#F2BB13] mb-1 sm:mb-2">{value.title}</h3>
                <p className="text-white text-xs sm:text-sm">{value.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default HistorySection;
